<template>
  <div>
    <v-dialog
      v-model="dialogOpen"
      max-width="420px"
      persistent
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="text-h6">
          Correo de recuperación
        </v-card-title>
        <v-card-text>
          <p class="mb-3 body-2">
            Debes registrar y verificar un correo personal. Ahí te enviaremos una
            contraseña temporal si olvidas tu acceso al KPI.
          </p>

          <template v-if="step === 'email'">
            <label class="caption text--secondary">Correo personal</label>
            <v-text-field
              v-model="email"
              type="email"
              outlined
              dense
              filled
              hide-details="auto"
              autocomplete="email"
              class="mb-2"
              :disabled="cargar"
              @keyup.enter="enviarCodigo"
            />
          </template>

          <template v-else>
            <v-alert dense outlined type="info" class="mb-3">
              <div v-if="debugCode">
                Ambiente de pruebas: tu código es
                <strong class="text-h6">{{ debugCode }}</strong>
              </div>
              <div v-else>
                Enviamos un código a <strong>{{ email }}</strong>
              </div>
            </v-alert>
            <label class="caption text--secondary">Código de 6 dígitos</label>
            <v-text-field
              v-model="code"
              outlined
              dense
              filled
              hide-details="auto"
              maxlength="6"
              :disabled="cargar"
              @keyup.enter="verificarCodigo"
            />
            <div class="text-right mt-1">
              <v-btn
                text
                x-small
                color="primary"
                class="text-none"
                :disabled="cargar"
                @click="step = 'email'"
              >
                Cambiar correo
              </v-btn>
            </div>
          </template>

          <v-alert v-if="errorMsg" type="error" dense outlined class="mt-3 mb-0">
            {{ errorMsg }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="step === 'email'"
            color="primary"
            outlined
            :loading="cargar"
            :disabled="cargar || !emailValido"
            @click="enviarCodigo"
          >
            Enviar código
          </v-btn>
          <v-btn
            v-else
            color="green"
            outlined
            :loading="cargar"
            :disabled="cargar || !codigoValido"
            @click="verificarCodigo"
          >
            Verificar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DialogoCorreoRecuperacion',

  data() {
    return {
      dialogOpen: false,
      step: 'email',
      email: '',
      code: '',
      debugCode: '',
      errorMsg: '',
      cargar: false,
      checkedOnce: false,
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    emailValido() {
      const e = String(this.email || '').trim()
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
    },

    codigoValido() {
      return /^\d{6}$/.test(String(this.code || '').trim())
    },

    necesitaCorreo() {
      // TEMPORAL: desactivar alerta de correo de recuperación
      return false
      /*
      const u = this.getdatosUsuarioERPERP
      if (!u || !u.iderp) return false
      if (Number(u.iderp) === 1) return false
      // Mientras deba cambiar contraseña, ese diálogo tiene prioridad
      if (!u.updatePassword) return false
      return Number(u.email_recuperacion_verificado) !== 1
      */
    },
  },

  watch: {
    getdatosUsuarioERPERP: {
      immediate: true,
      handler(usuario) {
        if (!usuario) {
          this.dialogOpen = false
          return
        }
        if (this.necesitaCorreo) {
          this.dialogOpen = true
          if (usuario.email_recuperacion && !this.email) {
            this.email = usuario.email_recuperacion
          }
        } else {
          this.dialogOpen = false
        }
      },
    },
  },

  methods: {
    ...mapActions('login', ['guardarInfo']),

    async enviarCodigo() {
      this.errorMsg = ''
      if (!this.emailValido) {
        this.errorMsg = 'Ingresa un correo válido.'
        return
      }
      this.cargar = true
      try {
        const { data } = await this.$http.post('password.recovery.email.save', {
          email: String(this.email).trim().toLowerCase(),
        })
        this.email = (data && data.email_recuperacion) || this.email
        this.debugCode = (data && data.debug_code) || ''
        if (this.debugCode) {
          this.code = this.debugCode
        }
        this.step = 'code'
      } catch (error) {
        this.errorMsg =
          (error.response && error.response.data && error.response.data.message) ||
          'No se pudo enviar el código.'
      } finally {
        this.cargar = false
      }
    },

    async verificarCodigo() {
      this.errorMsg = ''
      if (!this.codigoValido) {
        this.errorMsg = 'El código debe ser de 6 dígitos.'
        return
      }
      this.cargar = true
      try {
        const { data } = await this.$http.post('password.recovery.email.verify', {
          code: String(this.code).trim(),
        })
        const actual = Object.assign({}, this.getdatosUsuarioERPERP || {}, {
          email_recuperacion: data.email_recuperacion || this.email,
          email_recuperacion_verificado: 1,
        })
        await this.guardarInfo(actual)
        this.dialogOpen = false
        this.step = 'email'
        this.code = ''
      } catch (error) {
        this.errorMsg =
          (error.response && error.response.data && error.response.data.message) ||
          'No se pudo verificar el código.'
      } finally {
        this.cargar = false
      }
    },
  },
}
</script>
